<div class="spinner" fxLayout="column" fxLayoutAlign="center center" *ngIf="loading">
  <app-ellos-spinner [text]="'matchmaking.loading' | translate"> </app-ellos-spinner>
</div>
<div class="jitsi-styling" id="meet" class="meet"></div>
